import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, ConveniosReducer, ConveniosState } from "./convenios-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IConvenioPagedResponse } from "models/response/convenio-paged-response";

const ConveniosContext = createContext<ConveniosState | undefined>(undefined);
const ConveniosContextDispatchContext = createContext({} as any);

const ConveniosProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ConveniosReducer, {
        convenios: new PaginationResponse<IConvenioPagedResponse>([], 0, 1, 10, 0),
        convenioPagedRequest: { page: 0, pageSize: 10 },
        situacoes: [],
        ultimaAtualizacao: null,
        totais: { valorTotalConvenio: 0, valorTotalRepassado: 0 },
        loading: false,
        error: null
    } as ConveniosState);

    return (
        <ConveniosContext.Provider value={state}>
            <ConveniosContextDispatchContext.Provider value={dispatch}>
                {children}
            </ConveniosContextDispatchContext.Provider>
        </ConveniosContext.Provider>
    );
}

const useConveniosState = () => {
    const context = useContext(ConveniosContext);
    if (context === undefined) {
        throw new Error('useConveniosState must be used within a ConveniosProvider');
    }
    return context;
}

const useConveniosDispatch = () => {
    const context = useContext(ConveniosContextDispatchContext);
    if (context === undefined) {
        throw new Error('useConveniosDispatch must be used within a ConveniosProvider');
    }
    return context;
}

export { ConveniosProvider, useConveniosState, useConveniosDispatch, ACTION_TYPES };
